import type { useResgate } from '@/login/composables/useResgate';
import { useLoginStore } from '@/login/stores/useLoginStore';
import type { AttestationSummaryKeyValues } from '@sysarb/sysarb-types-v2/services/v1/pay-management';

/**
 * Get Review by draft id
 *  @param reviewId Salary review id
 */
export async function getAttestationOverviewKeyValues(resgate: ReturnType<typeof useResgate>, reviewId: string): Promise<AttestationSummaryKeyValues | null> {
    const { instanceTopic } = useLoginStore();
    const promise = resgate.model<AttestationSummaryKeyValues>(`v1.pay-management.subdomain.${instanceTopic}.attestation.${reviewId}.overviewkeyvalues`).then(res => {
        if (res?.success === false) return null;
        return res.data;
    });
    return promise;
}
